// Per-chart, exact-timestamp caches shared by the main chart and indicator axes.
// No rounded buckets: offsets at DST boundaries retain the library's semantics.
export function cacheTimezone(timezone, limit = 8192) {
  for (const method of ['offsetUTC', 'parseDate']) {
    const original = timezone[method].bind(timezone);
    const cache = new Map();
    timezone[method] = date => {
      const timestamp = date.getTime();
      if (!Number.isFinite(timestamp)) return original(date);
      if (!cache.has(timestamp)) {
        const result = original(date);
        if (cache.size >= limit) cache.delete(cache.keys().next().value);
        cache.set(timestamp, result);
      }
      const result = cache.get(timestamp);
      // Callers may modify parsed fields; don't expose the cached object.
      return method === 'parseDate' ? { ...result } : result;
    };
  }
  return timezone;
}
